import { Component, Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    template: require('./registrationPropertyIdHelper.component.html')
})
export class RegistrationPropertyIdHelperDialog {

    constructor(@Inject(MatDialogRef<RegistrationPropertyIdHelperDialog>) public dialogRef: MatDialogRef<RegistrationPropertyIdHelperDialog>) {}

    closeThisDialog(value: any){
        this.dialogRef.close(value)
    }
}
